import { Component, OnInit } from '@angular/core';

/**
 * Base Component for Patient Profile View
 */
export class PatientProfileComponentBase implements OnInit {
  PatientInfoLabel = 'Patient Info';
  WeeklyAssessmentLabel = 'Weekly CheckIn';
  GoalsLabel = 'Goals';
  ProgressLabel = 'Progress';
  PatientID = 0;
  NotificationToken = null;
  IsNotificationView: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.NotificationToken) this.IsNotificationView = true;
  }
}

/**
 * Component for Patient Profile (For logged-in users)
 */
@Component({
  selector: 'app-patient-profile',
  templateUrl: './patient-profile.component.html',
  styleUrls: ['./patient-profile.component.scss'],
})
export class PatientProfileComponent extends PatientProfileComponentBase {}

/**
 * Component for Patient Profile (For anonymous users)
 */
@Component({
  selector: 'app-patient-profile-anonymous',
  templateUrl: './patient-profile-anonymous.component.html',
  styleUrls: ['./patient-profile.component.scss'],
})
export class PatientProfileAnonymousComponent extends PatientProfileComponentBase {}
